import {
  mdiAccount,
  mdiAccountGroupOutline,
  mdiAccountMultipleOutline,
  mdiAlert,
  mdiBackspaceOutline,
  mdiBookEducationOutline,
  mdiBookSearchOutline,
  mdiChartBar,
  mdiCheckCircle,
  mdiCheckDecagramOutline,
  mdiClipboardEditOutline,
  mdiClipboardListOutline,
  mdiClipboardOutline,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiContentCopy,
  mdiCubeScan,
  mdiHelpRhombusOutline,
  mdiHistory,
  mdiHomeOutline,
  mdiInformation,
  mdiKeyboardOutline,
  mdiLayersOutline,
  mdiLightbulbQuestionOutline,
  mdiLightbulbVariantOutline,
  mdiMoonWaningCrescent,
  mdiNoteTextOutline,
  mdiPackageDown,
  mdiPencilOutline,
  mdiQrcodeScan,
  mdiRestart,
  mdiSchoolOutline,
  mdiStarCheck,
  mdiSwapHorizontal,
  mdiTrashCanOutline,
  mdiTrophy,
  mdiWebBox,
  mdiWhiteBalanceSunny
} from '@mdi/js'

export const MaterialIcons = {
  account: mdiAccount,
  help: mdiHelpRhombusOutline,
  keyboard: mdiKeyboardOutline,
  'qr-scan': mdiQrcodeScan,
  'school-cap': mdiSchoolOutline,
  home: mdiHomeOutline,
  'clip-board': mdiClipboardOutline,
  bulb: mdiLightbulbVariantOutline,
  checked: mdiCheckDecagramOutline,
  clock: mdiClockOutline,
  trophy: mdiTrophy,
  'bar-chart': mdiChartBar,
  clipboard: mdiClipboardListOutline,
  'bulb-question': mdiLightbulbQuestionOutline,
  star: mdiStarCheck,
  history: mdiHistory,
  restart: mdiRestart,
  info: mdiInformation,
  close: mdiClose,
  swap: mdiSwapHorizontal,
  check: mdiCheckCircle,
  x: mdiCloseCircle,
  note: mdiNoteTextOutline,
  alert: mdiAlert,
  backspace: mdiBackspaceOutline,
  sun: mdiWhiteBalanceSunny,
  moon: mdiMoonWaningCrescent,
  multiplayer: mdiAccountGroupOutline,
  packageDown: mdiPackageDown,
  webBox: mdiWebBox,
  performance: mdiBookEducationOutline,
  edit: mdiPencilOutline,
  editClipboard: mdiClipboardEditOutline,
  layers: mdiLayersOutline,
  trash: mdiTrashCanOutline,
  copy: mdiContentCopy,
  runs: mdiBookSearchOutline,
  'player-builds': mdiCubeScan,
  people: mdiAccountMultipleOutline
}

export type IconName = keyof typeof MaterialIcons
